<template>
  <div ref="scrollContainer" class="whole-div-PAU">
    <!--        第一行-->
    <div class="div1-PNC">
      <div class="div1-div1-PNC">
        <img src="../../public/image/浙江纵海4.jpg" alt="" width="100%" height="100%">
      </div>
    </div>
    <!--      第二行-->
    <div class="div2-PNC">
      <div class="div2-div-PNC">
        <!--      左侧导航栏-->
        <div class="div2-div-div-PNC">
          <div class="div2-div-div-div-PNC">
            <a style="font-weight: bold;font-size: 20px;color: #FFFFFF">新闻中心</a>
          </div>
          <div class="div2-div-div-div2-PNC" @click="navigationClick(0)" @mouseleave="navigationMouseLeave(0)"
               @mouseover="navigationMouserOver(0)" :style="{backgroundColor:navigationBgcColor[0]}">
            <a :style="{color:navigationTxtColor[0]}">行业新闻</a>
          </div>
          <div class="div2-div-div-div2-PNC" @click="navigationClick(1)" @mouseleave="navigationMouseLeave(1)"
               @mouseover="navigationMouserOver(1)" :style="{backgroundColor:navigationBgcColor[1]}">
            <a :style="{color:navigationTxtColor[1]}">常见问题</a>
          </div>
        </div>
        <!--      右侧内容栏-->
        <div class="div2-div-div2-PNC">
          <div style="width: 100%;height: 10px"></div>
          <router-view></router-view>
          <div style="width: 100%;height: 10px"></div>
        </div>
      </div>
    </div>

    <!-- 第9行：底框 -->
    <div class="div9-PFG">
      <div style="width: 25%;height: 100%"></div>
      <div class="div9-div1-PFG">
        <img src="../../public/image/浙江纵海.jpg" alt="" height="80%">
      </div>
      <div class="div9-div2-PFG">
        <div style="width: 60%;position: relative;text-align: left">
          <a style="font-size: 20px;font-weight: bold;">联系方式</a><br><br>
          <a >联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
          <a >手机号码：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
          <a>电话号码：{{this.$store.state.contactIntroduce.telephoneNumber}}</a><br>
          <a>地址：{{this.$store.state.contactIntroduce.address}}</a><br>
          <a>邮箱：{{this.$store.state.contactIntroduce.email}}</a>
        </div>
      </div>
      <div class="div9-div3-PFG">
        <div style="text-align: left">
          <a style="font-family: Avenir">Copyright © 2024</a><br><br>
          <a>版权所有©浙江纵海自动化设备有限公司</a><br>
          <a class="div9-div3-a1-PFG" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
          <a class="div9-div3-a1-PFG" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br><br>
          <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '../css/pc/PNC_PcNewsCenter.css'

  export default {
    name: "PcNews",
    data() {
      return {
        navigationID: 0,
        navigationBgcColor: ['lightgray', '#FFFFFF',],
        navigationTxtColor: ['blue', '#000000',],
      }
    },
    mounted() {
      this.scrollToTop();
    },
    methods: {
      //滚动置顶方法
      scrollToTop() {
        const position = 0;
        this.$refs.scrollContainer.scrollTop = position;
      },
      //点击左侧导航栏
      navigationClick(id) {
        this.navigationID = id;
        for (let i = 0; i < this.navigationBgcColor.length; i++) {
          if (i == this.navigationID) {
            this.navigationBgcColor[i] = 'lightgray';
            this.navigationTxtColor[i] = 'blue';
          } else {
            this.navigationBgcColor[i] = '#FFFFFF';
            this.navigationTxtColor[i] = '#000000';
          }
        }
        this.$forceUpdate();
        for (let i = 0; i < this.navigationBgcColor.length; i++) {
          if (id == 0) {
            this.$router.push("/PcNewsCenter")
          } else if (id == 1) {
            this.$router.push("/PcCommonQuestions")
          }
          ;
        }
      },
      //导航背景变化
      navigationMouserOver(id) {
        if (this.navigationID != id) {
          this.navigationBgcColor[id] = 'lightgray';
          this.navigationTxtColor[id] = 'blue';
          this.$forceUpdate();
        }
      },
      navigationMouseLeave(id) {
        if (this.navigationID != id) {
          this.navigationBgcColor[id] = '#FFFFFF';
          this.navigationTxtColor[id] = '#000000';
          this.$forceUpdate();
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/PcNewsCenter.vue